import {Form, InputNumber, message} from 'antd';
import {SFuncModal, SGeneralForms} from 'shj-components';
import {useRequest} from "ahooks";
import {realRetreatQualityMoney} from "@/services/qualityMoneyAccount.ts";
import { moneyRender } from '@/utils';

export function actualMoney({fn, ...rest}) {
    const onClose = () => {
        dialog.destroy();
    };
    const dialog = SFuncModal({
        title: '退质保金',
        width: 500,
        vanish: true,
        content: <AccountDetail onClose={onClose} fn={fn} {...rest} />,
    });

    return dialog;
}

const AccountDetail = ({onClose, fn, ...rest}) => {
    let [form] = Form.useForm();
    form.setFieldsValue({...rest.user,accountId: rest.accountId,accountBalance: `¥${moneyRender(rest?.user?.accountBalance)}`})
    let {
        loading: payLoading,
        runAsync: runAsyncPay
    } = useRequest(realRetreatQualityMoney, {manual: true});

    const changeActualReturnMoney = (state) => {
        if (state == '2') {
            onClose();
            return;
        }
        form.validateFields().then((values) => {
            console.error('values', values)
            let params = {
                accountId: rest.accountId,
                amount:values?.customAmount,
                changeDescribe:values?.changeDescribe
            }
            runAsyncPay({
                params: params
            }).then((res:any) => {
                message.success('操作成功!')
                fn && fn();
                onClose();
            })
        })
    };


    return (<SFuncModal.Content okText='提交退款' cancelText='取消' confirmLoading={payLoading}
                                onOk={() => changeActualReturnMoney(1)} onCancel={() => changeActualReturnMoney(2)}>
            <SGeneralForms
                isFooterBtn={false}
                isHideResetBtn={true}
                layout='vertical'
                formConfig={{form: form}}
                configs={[
                    {
                        title: '',
                        formItem: [
                            {
                                name: 'extEmpName',
                                label: '收款人：',
                                spanCol: 24,
                                comConfig: {
                                    disabled: true
                                }
                            },
                            {
                                name: 'accountBalance',
                                label: '可退金额：',
                                spanCol: 24,
                                comConfig: {
                                    disabled: true
                                }
                            },
                            {
                                name: 'customAmount',
                                label: '退款金额：',
                                required:true,
                                spanCol: 24,
                                rules: [
                                    {
                                        validator: (_, value) => {
                                            if (!value) {
                                                return Promise.resolve();
                                            } else {
                                                const amount = form.getFieldValue('accountBalance');
                                                if (Number(value) <= Number(amount)) {
                                                    return Promise.resolve();
                                                } else {
                                                    return Promise.reject('退款金额不能大于余额');
                                                }
                                            }
                                        },
                                    },
                                ],
                                children: (form, name) => {
                                    return <InputNumber placeholder="请输入退款金额" precision={2} min={0.01}/>;
                                },
                            },
                            {
                                name: 'changeDescribe',
                                label: '备注：',
                                spanCol: 24,
                                comConfig: {maxLength: 100,placeholder:"请输入备注"}
                            },
                        ],
                    },
                ]}
            />
        </SFuncModal.Content>
    );
};
